import styled from 'styled-components'

export const SidebarWrapper = styled.aside`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--secondary);
  color: white;
  padding: 20px 8px;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const Logo = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  h1{
    font-size: 2rem;
    margin: 0;
  }
`

export const SidebarMenu = styled.section`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  padding-right: 8px;
`

const MenuStyle = ({ active }) => `
  color: white;
  margin-bottom: 16px;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  display: block;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 6px;

  svg {
    font-size: 15px;
    margin-right: 8px;
  }

  &:hover {
    background-color: white;
    color: var(--primary);
  }

  ${active ? 'background-color: white; color: var(--primary);' : ''}
`

export const SingleMenu = styled.section`
  a { ${props => MenuStyle(props)} }
`

export const HasSubMenu = styled.section`
  ${props => MenuStyle(props)}
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  .sub-toggle {
    padding-left: 5px;
    svg { font-size: 12px; }
    &.hide{ transform: rotate(180deg); }
  }
`

export const SubMenuWrapper = styled.div`
  list-style: none;
  padding: 0;
  margin: 0;
  height: fit-content;
  max-height: 0;
  overflow: hidden;
  transition: 0.3s ease-in-out;

  ${({ active }) => active ? 'max-height: 500px;' : ''}
`

export const SubMenu = styled.div`
  margin-left: 8px;
  position: relative;

  a {
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    display: block;
    margin-bottom: 4px;
    line-height: 24px;
    padding: 6px 25px;
    transition: 0.3s;
    border-right: 3px solid transparent;
    color: white;
    text-decoration: none;
    &.active {
      color: var(--primary);
    }
  }

  &:hover {
    a {
      color: var(--primary);
    }
  }

  &:first-child {
    &::before {
      bottom: 0;
    }
  }
`
